import 'babel-polyfill'
import * as Stickyfill from 'stickyfilljs'

if (typeof window !== 'undefined') {
  window.Stickyfill = Stickyfill
}
